import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileCreateMutationAtom = createMutationAtomFactory(
  'files.create',
  (params: {
    fileName: string;
    fileSize: number;
    mimeType: string;
    fileType: 'Regular' | 'Directory';
    parentId?: string;
    public?: boolean;
    metadata?: Record<string, unknown>;
  }) => ({
    filesCreateFile: {
      __args: {
        input: {
          fileName: params.fileName,
          fileSize: params.fileSize,
          mimeType: params.mimeType,
          fileType: params.fileType,
          parentId: params.parentId,
          public: params.public ?? false,
          metadata: params.metadata ?? {},
        },
      },
      file: {
        id: true,
        fileName: true,
        fileType: true,
        uploadUrl: true,
      },
      uploadUrl: true,
    },
  }),
);
